import { z } from 'zod';

const appJsonUrlSchema = z.string().refine((url) => {
  if (
    url.startsWith('/') ||
    url.startsWith('.') ||
    url.includes('..') ||
    url.includes('\\') ||
    url.includes(' ') ||
    url.includes('//')
  ) {
    return false;
  }
  if (!url.endsWith('.js') && !url.endsWith('.css')) {
    return false;
  }
  return true;
});

export const appJsonSchema = z.object({
  app: z.string().min(1),
  version: z.string().min(1),
  timestamp: z.iso.datetime().optional(),
  cssUrls: z.array(appJsonUrlSchema).min(1),
  jsUrls: z.array(appJsonUrlSchema).min(1),
});

export type AppJson = z.infer<typeof appJsonSchema>;

export function isAppJson(obj: unknown): obj is AppJson {
  return appJsonSchema.safeParse(obj).success;
}
